import React, { useState, useContext } from 'react'
import SwipeableBottomSheet from 'react-swipeable-bottom-sheet'
import { PolicySummary } from './PolicySummary'
import FlexView from 'react-flexview/lib'
import { GreenButton } from '../Core/Buttons/GreenButton'
import { InsurancePurchaseContextStore } from '../../context/InsuracePurchaseContext'
import {
  FirebaseService,
  FirebaseConfigKey,
} from '../../services/FirebaseService'
import InfoIcon from '@material-ui/icons/Info'
import { Collapse, useMediaQuery } from '@material-ui/core'
import { GetAQuotePopup } from '../Quote/GetAQuotePopup'
import { useLocation } from 'react-router-dom'
import { BuyingInsuranceContextStore } from '../../context/BuyingInsuranceContext'
import {
  liabilityLimitPretty,
  billingPeriodPretty,
  isInFlow,
  KPretty,
  currencySymbol,
} from '../../services/utils'

export const BottomSheetPolicySummary = (props) => {
  const [policySummaryOpenMobile, setPolicySummaryOpenMobile] = useState(false)
  const insuranceContext = useContext(InsurancePurchaseContextStore)
  const offersContext = useContext(BuyingInsuranceContextStore)
  const location = useLocation()
  const [showOverflowTop, setShowOverflowTop] = useState(false)
  const isMobileByWidth = !useMediaQuery((theme) => theme.breakpoints.up('md'))

  const toggleBottomSheet = () => {
    setPolicySummaryOpenMobile(!policySummaryOpenMobile)
  }

  const openBottomSheet = (open) => {
    setPolicySummaryOpenMobile(open)
  }

  const onGreenButtonClick = (e) => {
    e.stopPropagation()
    props.onClick()
  }

  const onTransitionEnd = () => {
    setShowOverflowTop(policySummaryOpenMobile)
  }

  return (
    <SwipeableBottomSheet
      style={{ zIndex: 999 }}
      swipeableViewsProps={{ onTransitionEnd: onTransitionEnd }}
      open={policySummaryOpenMobile}
      onChange={openBottomSheet}
      shadowTip={false}
      overflowHeight={isMobileByWidth ? 70 : 96}>
      <Collapse in={!showOverflowTop}>
        {offersContext.pricebreakdown && offersContext.pricebreakdown.price ? (
          <>
            <div
              onClick={toggleBottomSheet}
              style={{
                height: 64,
                padding: isMobileByWidth ? 0 : 6,
              }}>
              <FlexView
                vAlignContent={'center'}
                hAlignContent={'center'}
                className="space-between margin-top-basic margin-right-50">
                <div>
                  <FlexView className="margin-top-3">
                    <div className="text-body black italic">Price:</div>
                    <FlexView
                      vAlignContent={'center'}
                      className="text-body margin-left-3 black bold">
                      {currencySymbol()}
                      {offersContext.pricebreakdown.price.toFixed(2)}
                    </FlexView>
                  </FlexView>
                </div>
                <GreenButton
                  className="continue-button-mobile"
                  onClick={onGreenButtonClick}>
                  {props.title}
                </GreenButton>
              </FlexView>
            </div>
          </>
        ) : null}
      </Collapse>
      {/* <FlexView hAlignContent={'center'}>
                <PolicySummary 
                    mobileExtension={<FlexView hAlignContent={'center'}>
                                    <GreenButton onClick={onGreenButtonClick}>{props.title}</GreenButton>
                                </FlexView>} />  
            </FlexView> */}
    </SwipeableBottomSheet>
  )
}
